import { useApiCallback } from "gf-ui";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Button, Container, Form, Modal } from "react-bootstrap";
import { FaCheck } from "react-icons/fa";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { annullaRisposteDipendenze, PAGINE, TIPOLOGIE } from ".";
import apiQuestionario from "../api/apiQuestionario";
import InputNumber from "../components/InputNumber";
import InputText from "../components/InputText";
import Select from "../components/Select";
import { MODULO_GRADIMENTO, TIPI_RISPOSTE } from "../constants";
import HeaderColon from "./coloneRetto/components/HeaderColon";
import HeaderSenologia from "./senologia/components/HeaderSenologia";
import PageContainer from "../components/PageContainer";


const ModuloGradimento = ({ tipologia }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const apiCallback = useApiCallback()
    const _apiQuestionario = useRef(new apiQuestionario(dispatch, apiCallback, null))
    _apiQuestionario.current.setFixedParams({ ID_TIPOLOGIA: tipologia.KID })
    const [scheda, setScheda] = useState(null)
    const [confirmCancel, setConfirmCancel] = useState(false)
    const [domande, setDomande] = useState({});
    const [risposte, setRisposte] = useState([])

    const header = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return <HeaderSenologia subtitle={`Compila il modulo di gradimento, e clicca su "Ho Terminato" una volta finito`} />;
                case TIPOLOGIE.COLON_RETTO.KID: return <HeaderColon subtitle={`Compila il modulo di gradimento, e clicca su "Ho Terminato" una volta finito`} />;
                default: return
            }
        }
    }, [tipologia])

    const idModello = useMemo(() => {
        if (tipologia) {
            switch (tipologia.KID) {
                case TIPOLOGIE.SENOLOGIA.KID: return MODULO_GRADIMENTO.SENOLOGIA;
                case TIPOLOGIE.COLON_RETTO.KID: return MODULO_GRADIMENTO.COLON_RETTO;
                default: return;
            }
        }
    }, [tipologia])

    const onChangeSelect = (kid, val) => {
        let dom = domande;
        let newVal = dom[kid];

        newVal.ARR_RISPOSTE.forEach((item, index) => {
            if (parseInt(item.ID_MA_CSS_D_R) === parseInt(val)) {
                newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '-1';
            } else {
                newVal.ARR_RISPOSTE[index].FLG_SELEZIONATA = '0';
            }
        })

        newVal.val = val;
        dom = {
            ...dom,
            [kid]: newVal
        }
        annullaRisposteDipendenze(dom)
        setDomande({ ...dom });
    }

    const onChangeInputNumber = (kid, val) => {

        //replace non-digits with blank
        val = val.replace(/[^\d]/, '');
        if (isNaN(parseInt(val))) {
            val = "";
        }

        let dom = domande;
        let newVal = dom[kid];

        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val;
        dom = {
            ...dom,
            [kid]: newVal
        }
        annullaRisposteDipendenze(dom)
        setDomande({ ...dom });
    }

    const onChangeInputText = (kid, val) => {
        let dom = domande;
        let newVal = dom[kid];

        newVal.ARR_RISPOSTE[0].VALORE = val;
        newVal.val = val;
        dom = {
            ...dom,
            [kid]: newVal
        }
        annullaRisposteDipendenze(dom)
        setDomande({ ...dom });
    }

    const elencoDomande = useCallback(() => {
        const params = {
            ID_MODELLO: idModello
        }

        _apiQuestionario.current.fnGetDomande(res => {
            setScheda(res.scheda)
        }, params)
    }, [idModello])

    const salvaRisposte = (e) => {
        e.preventDefault();

        const params = {
            SCHEDA: JSON.stringify(scheda),
            ID_MODELLO: idModello
        }

        _apiQuestionario.current.fnSalvaRisposte(res => {
            navigate(`/${tipologia.URL}${PAGINE.RISULTATO_GRADIMENTO.URL}`, { state: res });
        }, params)
    }

    const annulla = () => {
        setScheda(null)
        navigate(`/${tipologia.URL}${PAGINE.HOME_GRADIMENTO.URL}`)
    }

    useEffect(() => {
        if (scheda) {
            let elenco_domande = {};
            scheda && scheda.EN_MODELLO && scheda.EN_MODELLO.ARR_DOMANDE && scheda.EN_MODELLO.ARR_DOMANDE?.forEach((item, index) => {
                elenco_domande[index] = item;
            })
            setDomande(elenco_domande)

        } else {
            elencoDomande()
        }
    }, [elencoDomande, scheda])

    useEffect(() => {
        let ris = [];
        Object.keys(domande).forEach(id_domanda => {
            if (domande[id_domanda].val) {
                ris.push(domande[id_domanda].val)
            }
        })
        setRisposte(ris)
    }, [domande])

    return <PageContainer tipologia={tipologia}>
        <Form onSubmit={(e) => salvaRisposte(e)}>
            <Container className="bg-white pt-4 rounded">
                {header}
                {Object.keys(domande).map((kid, index) => {
                    const item = domande[kid];
                    switch (item.TIPO_RISPOSTA) {
                        case TIPI_RISPOSTE.COMBO:
                            return (
                                <Select key={index}
                                    kid={kid}
                                    domanda={item.DESCRIZIONE}
                                    domande={domande}
                                    risposte={item.ARR_RISPOSTE}
                                    mostraSe={item.ARR_RIFERIMENTI}
                                    value={item.val}
                                    onChange={onChangeSelect} />
                            );
                        case TIPI_RISPOSTE.NUMERO:
                            return (
                                <InputNumber key={index}
                                    kid={kid}
                                    domanda={item.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={item.ARR_RIFERIMENTI}
                                    value={item.val || ""}
                                    placeholder={item.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputNumber} />
                            )
                        case TIPI_RISPOSTE.TESTO:
                            return (
                                <InputText key={index}
                                    kid={kid}
                                    domanda={item.DESCRIZIONE}
                                    domande={domande}
                                    mostraSe={item.ARR_RIFERIMENTI}
                                    value={item.val || ""}
                                    placeholder={item.ARR_RISPOSTE[0].DESCRIZIONE}
                                    onChange={onChangeInputText} />
                            )
                        default:
                            return null;
                    }
                })
                }

                <Form.Group className="mb-3 form-group">
                    <div className="d-grid gap-2 m-2">
                        <Button type="button" variant="outline-secondary" className="btn-lg" onClick={() => setConfirmCancel(true)}>ANNULLA</Button>
                        {risposte.length > 0 && (
                            <Button type="submit" variant="success" className="btn-lg"><strong style={{ fontSize: '2rem' }}><FaCheck /> HO TERMINATO</strong></Button>
                        )}
                    </div>
                </Form.Group>

            </Container>

            <Modal show={confirmCancel} className="d-flex modal-dialog-centered">
                <Modal.Body className="text-center modal-loading">
                    <h1 style={{ color: 'steelblue' }}>Vuoi veramente uscire?</h1>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" onClick={() => setConfirmCancel(false)}>Annulla</Button>
                    <Button variant="primary" onClick={annulla} className="text-light">Conferma</Button>
                </Modal.Footer>
            </Modal>

        </Form>
    </PageContainer>
}

export default ModuloGradimento;
